import { useCallback, useRef } from 'react'

const useDebouncedCallback = (callback, delay) => {
  const timerRef = useRef()

  const debouncedCallback = useCallback(
    (...args) => {
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        callback(...args)
      }, delay)
    },
    [callback, delay]
  )

  useCallback(() => {
    return () => clearTimeout(timerRef.current)
  }, [])

  return debouncedCallback
}

export default useDebouncedCallback
